import { Component, Input, OnInit } from '@angular/core';
import { ViewCell } from '../ofbiz-form-model';
import { Cell } from 'angular2-smart-table';

@Component({
  template: `
    <div>{{renderValue}}</div>
  `,
})
export class OfbizCellDisplayComponent  implements ViewCell, OnInit {
  @Input() cell: Cell; // Cell type is not defined in the original code, assuming it's a generic type
  @Input() value: string | number;
  @Input() rowData: any;
  renderValue: string;

  constructor() { }

  ngOnInit(): void {
   this.value = this.cell.getValue();
   this.rowData = this.cell.getRow().getData();
   this.renderValue = this.value?this.value.toString():"";
   console.log({"GettingDisplayValue":this.renderValue});
  }

  setDisplayString(fields:any[]){
    console.log(fields);
  }

}
